import theme from "@/theme";

const riskLevel: Record<string, string> = {
  healthy: "healthy",
  needAttention: "needAttention",
  needsSupport: "needsSupport",
};

const riskLevelRAGColors: Record<string, string> = {
  healthy: theme.palette.accent1.main,
  needAttention: theme.palette.secondary[700] as string,
  needsSupport: theme.palette.error.main,
};

export { riskLevelRAGColors, riskLevel };
